import ChartSeriesDto from "./ChartSeriesDto";

export default class ChartsConfigDto {
  static fromApi(data) {
    return ChartSeriesDto.fromApi(data);
  }

  static fromApiArray(data) {
    return data.availableIndices
      .filter((s) => s.isSelectable)
      .map(this.fromApi);
  }
}
